import { Helmet } from 'react-helmet';
import seoMetaData from '../../../Include/Seo/seoMetaData';
import Navbar from '../../../Include/Navbar/Navbar';
import Footer from '../../../Include/Footer/Footer';
import Breadcrumb from '../MobileApp/Breadcum';
import breadcrumbData from '../Data/breadcrumbData';
import whyusData from '../Data/whyusData';
import aboutData from '../Data/aboutData';
import contactData from '../Data/contactData';
import faqData from '../Data/faqData';
import '../../../../assets/css/services.css'; // Importing the CSS file for this component
import About from '../MobileApp/About';
import Whyus from '../MobileApp/Whyus';
import Contact from '../MobileApp/Contact';
import Faq from '../MobileApp/Faq';
import Contactus from '../../Home/Contact';

export default function Index() {
  const { title, description, keywords } = seoMetaData.migrationServices;
  return (
    <>
     <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href="https://www.cloudkode.com/services/migration-services" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "What types of migration services do you offer?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We offer data migration, application migration, and cloud migration services."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How do you ensure data integrity during migration?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We use advanced tools and techniques to validate data before, during, and after the migration process."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can you help with legacy system migrations?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we specialize in migrating legacy systems to modern platforms with minimal disruption."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you provide post-migration support?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely, we offer comprehensive post-migration support to ensure everything runs smoothly."
                  }
                }
              ]
            }
          `}
        </script>
      </Helmet>
   <Navbar />
   <Breadcrumb data={breadcrumbData.migration} /> 
   <About data={aboutData.migration} />
   <Whyus data={whyusData.migration}/>
   <Contact data={contactData.migration}/>
   <Faq data={faqData.migration}/>
   <Contactus/>
   <Footer/>
   </>
  )
}
